import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "c51b412c-6620-4804-bef7-d9ecb736f888",
  publicId: "3",
  name: "Convolution",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, task01, task02],
};

export default lesson;
